/*
 * Copyright © 2024-2026 symecode.com. All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution is prohibited.
 */


import React from 'react';
import { Participant } from '../../types';
import './Modal.css';

interface ParticipantModalProps {
  participant: Participant;
  onClose: () => void;
}

const ParticipantModal: React.FC<ParticipantModalProps> = ({ participant, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Participant Details</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="detail-grid">
            <div className="detail-row">
              <span className="detail-label">Username:</span>
              <span className="detail-value">{participant.username}</span>
            </div>
            {participant.firstName && (
              <div className="detail-row">
                <span className="detail-label">First Name:</span>
                <span className="detail-value">{participant.firstName}</span>
              </div>
            )}
            {participant.lastName && (
              <div className="detail-row">
                <span className="detail-label">Last Name:</span>
                <span className="detail-value">{participant.lastName}</span>
              </div>
            )}
            <div className="detail-row">
              <span className="detail-label">Type:</span>
              <span className="detail-value">{participant.type}</span>
            </div>
            {participant.company && (
              <div className="detail-row">
                <span className="detail-label">Company:</span>
                <span className="detail-value">{participant.company.name}</span>
              </div>
            )}
            {participant.manager && (
              <div className="detail-row">
                <span className="detail-label">Manager:</span>
                <span className="detail-value">
                  {participant.manager.firstName} {participant.manager.lastName}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button className="button button-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParticipantModal;
